import { ITrack } from '../../interfaces/track';
import { IMealGroup } from '../../interfaces/mealGroup';
import { MealGroups } from './mealGroup';

export class Track implements ITrack {
  _id: string;
  carb: number;
  date: Date;
  fat: number;
  kcal: number;
  mealGroups: IMealGroup[];
  prot: number;
  timezone: string;
  userId: string;

  constructor(item: ITrack) {
    Object.keys(item).forEach((key) => {
      if (key === 'mealGroups') {
        this[key] = new MealGroups(item[key]).mealGroups;
      } else {
        this[key] = item[key as keyof Track];
      }
    });
  }

  getTotal(key): string {
    return this.mealGroups.reduce((acc: number, mealGroup: IMealGroup) => {
      return acc + +mealGroup.getTotal(key)
    }, 0).toFixed(1)
  }

  getStats() {
    return [
      { key: 'fat', value: this.getTotal('fat') },
      { key: 'carb', value: this.getTotal('carb') },
      { key: 'prot', value: this.getTotal('prot') },
      { key: 'kcal', value: this.getTotal('kcal') },
    ];
  }
}

export class Tracks {
  tracks: Track[];

  constructor(items: ITrack[]) {
    this.tracks = items.map((track) => new Track(track));
  }
}
